module.exports = __webpack_public_path__ + "img/buddy_ears-06.19c77844.svg";